import { ApplyPrefix } from '@commons/constants';
import gql from 'graphql-tag';
export const VARIANT_FRAGMENT = gql `
  fragment VariantFragment on ProductVariant {
    id
    title
    sku
    availableForSale
    requiresShipping
    price {
      amount
      currencyCode
    }
    compareAtPrice {
      amount
      currencyCode
    }
    weight
    weightUnit
    quantityAvailable
    selectedOptions {
      name
      value
    }
    image {
      id
      originalSrc
      url
      altText
    }
    metafields(
      identifiers: [
        { namespace: "SB-P", key: "DisplayConversionFactor" }
        { namespace: "SB-P", key: "DisplayUnit" }
        { namespace: "SB-P", key: "DefaultConversionFactor" }
        { namespace: "SB-P", key: "DefaultUnit" }
        { namespace: "SB-Discount", key: "CONFIGS" }
      ]
    ) {
      id
      key
      namespace
      type
      value
    }
  }
`;
// Create a shared fragment for Product data
export const PRODUCT_FRAGMENT = gql `
  ${VARIANT_FRAGMENT}
  fragment ProductFragment on Product {
    id
    title
    handle
    description
    descriptionHtml
    productType
    vendor
    tags
    createdAt
    updatedAt
    publishedAt
    onlineStoreUrl
    availableForSale
    options {
      id
      name
      values
    }
    metafields(
      identifiers: [
        { namespace: "SB-P", key: "DisplayConversionFactor" }
        { namespace: "SB-P", key: "DisplayUnit" }
        { namespace: "SB-P", key: "DefaultConversionFactor" }
        { namespace: "SB-P", key: "DefaultUnit" }
        { namespace: "SB-Discount", key: "CONFIGS" }
        { namespace: "SB-P", key: "PRODUCT_VARIANT_ROOT" }
      ]
    ) {
      id
      key
      namespace
      type
      value
    }
    featuredImage {
      id
      originalSrc
      url
      altText
    }
    images(first: 2) {
      nodes {
        id
        originalSrc
        url
        altText
        width
        height
      }
    }
    collections(first: 10) {
      nodes {
        id
        title
        handle
      }
    }
    seo {
      title
      description
    }
    priceRange {
      minVariantPrice {
        amount
        currencyCode
      }
      maxVariantPrice {
        amount
        currencyCode
      }
    }
    variants(first: 5) {
      nodes {
        ...VariantFragment
      }
    }
  }
`;
export const SEARCH_PRODUCT = gql `
  ${PRODUCT_FRAGMENT}
  query searchProducts($query: String!, $first: Int, $productFilters: [ProductFilter!]) {
    search(query: $query, first: $first, types: PRODUCT, productFilters: $productFilters) {
      nodes {
        ...ProductFragment
      }
    }
  }
`;
export const COLLECTION_PRODUCTS = gql `
  ${PRODUCT_FRAGMENT}
  query collectionProducts($collectionId: ID!, $first: Int!, $filters: [ProductFilter!]) {
    collection(id: $collectionId) {
      id
      title
      products(first: $first, filters: $filters) {
        nodes {
          ...ProductFragment
        }
      }
    }
  }
`;
export const PRODUCT_BY_IDS = (ids) => gql `
  ${PRODUCT_FRAGMENT}
  query productsByIds {
    ${ids
    .map((id) => ApplyPrefix('PRODUCT', id))
    .map((id, index) => `product_${index}: product(id: "${id}") { ...ProductFragment }`)
    .join('\n')}  
  }
`;
export const PRODUCT_RECOMMENDATIONS = gql `
  ${PRODUCT_FRAGMENT}
  query productRecommendations($productId: ID!, $intent: ProductRecommendationIntent) {
    productRecommendations(productId: $productId, intent: $intent) {
      ...ProductFragment
    }
  }
`;
// export const PRODUCT_RECOMMENDATIONS_BY_IDS = (ids: string[]) => gql`
//   ${PRODUCT_FRAGMENT}
//   query productRecommendationsByIds {
//     ${ids
//       .map((id) => ApplyPrefix('PRODUCT', id))
//       .flatMap((id, index) => [
//         `related_${index}: productRecommendations(productId: "${id}") { ...ProductFragment }`,
//         `complementary_${index}: productRecommendations(productId: "${id}",intent: COMPLEMENTARY) { ...ProductFragment }`,
//       ])
//       .join('\n')}
//   }
// `;
export const PRODUCT_RECOMMENDATIONS_BY_IDS = (productIds, reccomendedProductIds, collectionIds) => gql `
  ${PRODUCT_FRAGMENT}
  query productAndRecommendations ${collectionIds.length > 0 ? '($first: Int, $filters: [ProductFilter!])' : ''} {
    ${productIds
    .map((id) => ApplyPrefix('PRODUCT', id))
    .map((id, index) => `product_${index}: product(id: "${id}") { ...ProductFragment }`)
    .join('\n')}
    ${reccomendedProductIds
    .map((id) => ApplyPrefix('PRODUCT', id))
    .flatMap((id, index) => [
    `related_${index}: productRecommendations(productId: "${id}") { ...ProductFragment }`,
    `complementary_${index}: productRecommendations(productId: "${id}",intent: COMPLEMENTARY) { ...ProductFragment }`,
])
    .join('\n')}
    ${collectionIds
    .map((id) => ApplyPrefix('COLLECTION', id))
    .map((id, index) => `collection_${index}: collection(id: "${id}") {  products(first: $first, filters: $filters) { nodes { ...ProductFragment } } }`)
    .join('\n')}
  }
`;
